export const getSupportCannedsRoute = () => '/canned';
export const getSupportCannedEditRoute = (cannedId) => '/canned/' + (cannedId ?? ':cannedId');